import { prettyNumberTransform } from './pretty-number.util'
import { Pipe, PipeTransform } from '@angular/core'

@Pipe({
  name: 'prettyNumber'
})
export class PrettyNumberPipe implements PipeTransform {
  public transform(number: number | string | undefined | null, type: 'int' | 'float' = 'int'): string | number {
    return prettyNumberTransform(number, type)
  }
}
